
import React from 'react';

interface TemplatePreviewProps {
  htmlContent: string;
  textContent: string;
}

export const TemplatePreview: React.FC<TemplatePreviewProps> = ({
  htmlContent,
  textContent
}) => {
  return (
    <div className="border p-4 rounded bg-background">
      <h3 className="text-lg font-bold mb-4">HTML Preview</h3>
      <div 
        className="prose dark:prose-invert max-w-none" 
        dangerouslySetInnerHTML={{ __html: htmlContent }} 
      />
      
      <h3 className="text-lg font-bold mt-6 mb-2">Text Preview</h3>
      <pre className="bg-muted p-4 rounded overflow-auto">
        {textContent}
      </pre>
    </div>
  );
};
